module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_9006.0f9f703e.png";